import { TableSortState, TableSortStateType } from '@novonordisk/novoui-vuejs';
const sortNumerically = <T extends Record<string, any>>(
    items: T[],
    sortState: TableSortStateType,
    key: string,
) => {
    switch (sortState) {
        case TableSortState.asc:
            return items.slice().sort((a, b) => {
                if (parseInt(a[key as string]) < parseInt(b[key as string]))
                    return -1;
                if (parseInt(a[key as string]) > parseInt(b[key as string]))
                    return 1;
                return 0;
            }); // Sort ascending
        case TableSortState.desc:
            return items.slice().sort((a, b) => {
                if (parseInt(b[key as string]) < parseInt(a[key as string]))
                    return -1;
                if (parseInt(b[key as string]) > parseInt(a[key as string]))
                    return 1;
                return 0;
            }); // Sort descending
        default:
            return items; // No sorting
    }
};

const sortAlphabetically = <T extends { [key: string]: string }>(
    items: T[],
    sortState: TableSortStateType,
    key: string,
) => {
    switch (sortState) {
        case TableSortState.asc:
            return items.slice().sort((a, b) => a[key].localeCompare(b[key])); // Sort ascending
        case TableSortState.desc:
            return items.slice().sort((a, b) => b[key].localeCompare(a[key])); // Sort descending
        default:
            return items; // No sorting
    }
};

export const sorting = <T extends Record<string, any>>(
    sorting: Map<string, TableSortStateType>,
    items: T[],
    alphabetical: boolean,
) => {
    let sortColumn: string = '';
    let sortState: TableSortStateType = TableSortState.none; // Initialize with default value
    // Iterate through the sorting map to find the first column with a non-"none" sort state
    sorting.forEach((state, column) => {
        if (state !== TableSortState.none) {
            sortColumn = column;
            sortState = state;
        }
    });
    if (alphabetical) {
        return sortAlphabetically(items, sortState, sortColumn);
    }
    return sortNumerically(items, sortState, sortColumn);
};
